export default __webpack_public_path__ + "static/media/caroussel_bubbles.9508a02a.jpg";